import { useState } from 'react'
import { Text, Box, Image } from '@chakra-ui/react'
import PalomaLogo from 'asset/logo.jpg'
import ChoiceSelect from './submission/ChoiceSelect'
import DetailForm from './submission/DetailForm'
import { Panel, Eyebrow, Stepper, PrimaryButton, tokens } from './submission/ui'

const steps = {
  ageGroup: 'age-group',
  detailForm: 'detail-form',
  thankyou: 'thankyou'
}

const stepLabels = ['Age group', 'Details', 'Submitted']
const stepIndex = {
  [steps.ageGroup]: 0,
  [steps.detailForm]: 1,
  [steps.thankyou]: 2,
}

const SubmitForm = () => {
  const [step, setStep] = useState(steps.ageGroup)
  const [talent, setTalent] = useState(null)
  const [ageGroup, setAgeGruop] = useState([0, 'Babies'])

  const handlePostSubmit = async (talent) => {
    setTalent(talent)
    setStep(steps.thankyou)
  }

  return (
    <Box bg="#fbfcfb" minH="100vh" color={tokens.text}>
      <Box maxW="1180px" mx="auto" px={{ base: 4, md: 8 }} pb={{ base: 16, md: 24 }}>

        <Box textAlign="center" pt={{ base: 10, md: 16 }} pb={{ base: 8, md: 12 }}>
          {/* The logo is the wordmark, so it stands in for the agency-name
              eyebrow rather than sitting above a duplicate of it.
              `logo.jpg` has a baked-in white background with no alpha, which
              shows as a white box against this off-white page — multiply blends
              it away without needing a transparent asset. Drop this if a PNG or
              SVG with real transparency ever replaces it. */}
          <Image
            src={PalomaLogo}
            alt="Paloma Model &amp; Talent"
            width={{ base: '200px', md: '240px' }}
            mx="auto"
            mb={{ base: 6, md: 7 }}
            sx={{ mixBlendMode: 'multiply' }}
          />
          <Text
            as="h1"
            fontSize={{ base: '38px', md: '52px' }}
            lineHeight="1.05"
            color={tokens.ink}
            mb={{ base: 7, md: 9 }}
          >
            Talent Submission
          </Text>
          <Stepper steps={stepLabels} current={stepIndex[step]} />
        </Box>

        {/* Steps are hidden rather than unmounted: DetailForm holds the entered
            values in local state, so conditional rendering would wipe the form
            every time someone stepped back to change the age group. */}
        <Box display={step === steps.ageGroup ? 'block' : 'none'}>
          <ChoiceSelect setAgeGruop={group => {
            setAgeGruop(group)
            setStep(steps.detailForm)
          }} />
        </Box>

        <Box display={step === steps.detailForm ? 'block' : 'none'} width='100%'>
          <DetailForm
            key={ageGroup[1]}
            ageGroup={ageGroup}
            postSubmit={handlePostSubmit}
            back={() => { setStep(steps.ageGroup) }}
          />
        </Box>

        <Box display={step === steps.thankyou ? 'block' : 'none'}>
          {talent && (
            <Panel containerProps={{ maxW: '640px', mx: 'auto' }}>
              <Box textAlign="center" py={{ base: 4, md: 8 }}>
                <Eyebrow mb="18px">Submission received</Eyebrow>
                <Text
                  fontSize={{ base: '30px', md: '38px' }}
                  lineHeight="1.1"
                  color={tokens.ink}
                  mb={5}
                >
                  Thank you for your submission
                </Text>
                <Text fontSize="16px" lineHeight="1.65" color={tokens.text} mb={2}>
                  We&rsquo;ll notify you at{' '}
                  <Text as="span" fontWeight="700" color={tokens.ink}>
                    {talent && talent.email}
                  </Text>{' '}
                  once we have reviewed your submission.
                </Text>
                <Text fontSize="14px" lineHeight="1.6" color={tokens.muted} mb={9}>
                  If you don&rsquo;t see a confirmation email, please check your spam
                  or junk folder before re-submitting.
                </Text>
                <PrimaryButton onClick={() => {
                  window.location.href = 'https://palomamodelandtalent.com/'
                }}>
                  Go Home
                </PrimaryButton>
              </Box>
            </Panel>
          )}
        </Box>

      </Box>
    </Box>
  )
}

export default SubmitForm
